import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      fill="#F4F4F5"
      d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z"
    />
    <path
      stroke="#52525B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 14h.01M18 27h4m-1.5-13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1.1 16h1.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C27 26.96 27 25.84 27 23.6v-7.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C23.96 10 22.84 10 20.6 10h-1.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C13 13.04 13 14.16 13 16.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C16.04 30 17.16 30 19.4 30Z"
    />
  </svg>
)
export default SvgComponent
